export class DateParam {
  day: string;
  monthYear: string;

  constructor(day: string, monthYear: string) {
    this.day = day;
    this.monthYear = monthYear;
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/common/model/date-param.model.ts